
import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import Config from '@/utils/config';
import DB from '@/utils/api/DB';
import api from '@/utils/api';
@Component
export default class DocCheck extends Vue {

    UID = DB.Get('user.info').id;

    @Prop({ default: null })
    Row!: any;

    Config = Config;

}
